import { render, staticRenderFns } from "./login-phone.vue?vue&type=template&id=d89a23d6&scoped=true"
import script from "./login-phone.vue?vue&type=script&lang=js"
export * from "./login-phone.vue?vue&type=script&lang=js"
import style0 from "./login-phone.vue?vue&type=style&index=0&id=d89a23d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_5bba9927a18eaff02a55b79fc72fdde2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89a23d6",
  null
  
)

export default component.exports